import { render, staticRenderFns } from "./CargoRateSelect.vue?vue&type=template&id=5ed05806&scoped=true"
import script from "./CargoRateSelect.vue?vue&type=script&lang=js"
export * from "./CargoRateSelect.vue?vue&type=script&lang=js"
import style0 from "./CargoRateSelect.vue?vue&type=style&index=0&id=5ed05806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed05806",
  null
  
)

export default component.exports